import { actionsDefinition } from '../actionsDefinition';

export const clearUpsertLevelAction = () => (dispatch: any) => {
    dispatch(clearUpsertLevelCompleted());
}

const clearUpsertLevelCompleted = () => ({
    type: actionsDefinition.levels.CLEAR_UPSERT_LEVEL_COMPLETED
});
